import React, { useEffect, useState } from "react";
import { Bell, BellOff, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { pushSupported, getSubscription, subscribeToPush, unsubscribeFromPush } from "@/lib/push";

export function PushToggle() {
  const [supported] = useState(pushSupported());
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!supported) return;
    getSubscription().then((s) => setEnabled(!!s)).catch(() => {});
  }, [supported]);

  if (!supported) {
    return <span className="text-xs text-muted-foreground" data-testid="push-unsupported">Not supported here</span>;
  }

  const toggle = async () => {
    setBusy(true);
    try {
      if (enabled) {
        await unsubscribeFromPush();
        setEnabled(false);
        toast.success("Reminders turned off.");
      } else {
        await subscribeToPush();
        setEnabled(true);
        toast.success("Reminders on — we'll nudge you to practise 🦉");
      }
    } catch (e) {
      if (e.message === "permission_denied") toast.error("Allow notifications in your browser to enable reminders.");
      else toast.error("Could not update reminders.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={toggle}
      disabled={busy}
      data-testid="push-toggle-btn"
      className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-colors shrink-0 ${
        enabled ? "emerald-surface text-white" : "bg-secondary hover:bg-accent"
      }`}
    >
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : enabled ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
      {enabled ? "Reminders on" : "Enable reminders"}
    </button>
  );
}
